var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ibi-cont"},[_c('ChartsLayout',{attrs:{"chartview":_vm.chartview,"class_chart":"ibi-chart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }